import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import initDateTimePickers from '../../init/datetimepicker';
import initZelect from '../../init/zelect';
import JourneyTemplatePolyline, { journeyTemplateShape } from './polyline';

$(document).off('gm:sidebar:show.journey_template').on('gm:sidebar:show.journey_template', () => {
  initDateTimePickers();
  initZelect();

  const $buttons = $('#journey-frequency button');
  $buttons.off('click').on('click', ({ currentTarget }) => {
    $buttons.removeClass('active');
    $(currentTarget).addClass('active');
    $('#journey_template_frequency').val($(currentTarget).data('frequency'));
  });

  $('.page.page-networks #journey_template_start_date').off('dp.change').on('dp.change', ({ currentTarget }) => {
    const $dateInput = $(currentTarget);
    $dateInput.siblings('#journey_template_day').val(moment($dateInput.val(), 'DD.MM.YYYY').format('dddd').toLowerCase());
  });
  $('.page.page-networks a[data-refresh-form-url]').off('click').on('click', ({ currentTarget }) => {
    const $currentTarget = $(currentTarget);
    const $form = $currentTarget.parents('form');
    const url = $currentTarget.data('refresh-form-url');
    if (!$form.length || !url) { return; }
    $.ajax({
      url,
      dataType: 'script',
      method: 'PUT',
      data: $form.serialize(),
    });
  });

  $('.stoppable-select').off('change').change(({ currentTarget }) => {
    const $formGroup = $(currentTarget).closest('.form-group');
    const stoppable = JSON.parse($(currentTarget).val());
    $formGroup.children('input').filter((i, el) => el.id.endsWith('stoppable_id')).val(stoppable.id);
    $formGroup.children('input').filter((i, el) => el.id.endsWith('stoppable_type')).val(stoppable.type);
  });

  $('#button-load-vehicles, #button-load-drivers')
    .off('click')
    .on('click', ({ currentTarget }) => $(currentTarget).addClass('hide').siblings('.hide').removeClass('hide'));
});

export default class JourneyTemplatePolylines extends Component {
  componentDidMount() {
    $(document).off('gm:sidebar:show.journey_templates').on('gm:sidebar:show.journey_templates', this.onSidebarShow.bind(this));
  }

  componentWillUnmount() {
    $(document).off('gm:sidebar:show.journey_templates');
    $('.zearch').off('focus');
    $('.zearch').off('blur');
    this.props.onClickCapture(this);
  }

  onSidebarShow() {
    $('.zearch').off('focus').focus(({ currentTarget }) => {
      this.focusedSelect = $(currentTarget).parents('.zelect').siblings('select.zelect');
      this.props.onClickCapture(this);
    });
    $('select.zelect').off('hide').on('hide', () => {
      setTimeout(() => { this.releaseClickHandler(); }, 1000);
    });
  }

  onStopClick(stop) {
    if (stop.kind !== 'scholar') { return false; }
    this.focusedSelect.zelectItem({ label: stop.name, value: JSON.stringify({ id: stop.id, type: 'Stop' }) });
    this.releaseClickHandler();
    return true;
  }

  onSchoolClick(school) {
    this.focusedSelect.zelectItem({ label: school.name, value: JSON.stringify({ id: school.id, type: 'School' }) });
    this.releaseClickHandler();
    return true;
  }

  releaseClickHandler() {
    this.focusedSelect = null;
    this.props.onClickRelease(this);
  }

  render() {
    const { journeyTemplates, selectedId, onClick, zoom } = this.props;
    return (
      <div>
        {_.map(journeyTemplates, jt => (
          <JourneyTemplatePolyline
            key={jt.id}
            journeyTemplate={jt}
            zoom={zoom}
            selected={selectedId === jt.id}
            onClick={onClick}
          />))}
      </div>
    );
  }
}

JourneyTemplatePolylines.defaultProps = {
  selectedId: null,
};

JourneyTemplatePolylines.propTypes = {
  journeyTemplates: PropTypes.arrayOf(journeyTemplateShape).isRequired,
  selectedId: PropTypes.number,
  zoom: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  onClickCapture: PropTypes.func.isRequired,
  onClickRelease: PropTypes.func.isRequired,
};
